import { createTheme } from "@mui/material/styles";

export default createTheme({
  palette: {
    primary: {
      main: "#cda45e",
      green: "#aa3560",
      fiolet: "#aa3560",
      red: "#073229",
    },
    secondary: {
      main: "#073229",
      light: "#1f463e",
      beige: "rgba(245,237,224, 0.6)",
      background: "rgba(245,237,224, 0.65)",
      bgmain: "rgba(130,147,148, 1)",
      red: "rgba(170,53, 96, 0.8)",
    },
    text: {
      light: "white",
      dark: "#073229",
      main: "#cda45e",
      red: "#a07744",
      green: "#e8dbbc",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        heroButton: {
          fontSize: 45,
          letterSpacing: "0.5px",
          textTransform: "uppercase",
          display: "inline-block",
          padding: "10px 28px",
          margin: "0px 2px 0px 0px",
          borderRadius: "50px",
          transition: "0.3s",
          lineHeight: 1,
          color: "white",
          border: "2px solid #cda45e",
          "&:hover": {
            backgroundColor: "#cda45e",
            color: "#fff",
          },
        },
      },
    },
  },

  typography: {
    h5: {
      fontSize: "25px",
      fontFamily: ["Montserrat", " sans-serif"].join(","),
    },
    // h6: {
    //   fontSize: "25px",
    //   fontFamily: ["Mrs Saint Delafield", "cursive"].join(","),
    // },
    fontFamily: ["Montserrat", " sans-serif"].join(","),
    h1: {
      fontSize: "40px",
      fontFamily: ["Cinzel Decorative", "serif"].join(","),
    },
    allVariants: {
      fontFamily: ["Montserrat", " sans-serif"].join(","),
    },
  },
});
